export const SET_USER_CANDLES_DATA = "USERS_CANDLES::SET::DATA"
export const SET_CANDLES_REACTION = "USERS_CANDLES::SET::CANDLE"
